<template>
  <app-layout>
    <Head title="Keywords"/>
    <template #header>
      <div class="flex justify-between">
        <h2 class="font-semibold text-xl text-gray-800 leading-tight">
          Create a new Keyword
        </h2>
      </div>
    </template>

    <div class="max-w-7xl mx-auto flex mb-6">
      <div class="w-full sm:px-6 lg:px-8">
        <div class="bg-white shadow-xl sm:rounded-lg sm:p-6 lg:p-8">
          <form @submit.prevent="submitHandler">
            <div class="tra__keyword-form flex flex-wrap relative">
              <div class="w-1/2 lg:pr-2">
                <jet-input
                  v-model="form.keyword"
                  type="text"
                  placeholder="KEYWORD"
                  label="Keyword"
                  class="uppercase mb-3 w-full block w-full px-3 py-2 transition duration-100 ease-in-out border rounded shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed text-black placeholder-gray-400 bg-white border-gray-300 focus:border-blue-500"
              </jet-input>
              <div class="subtext text-sm text-gray-500 mb-8">Keywords can be between 3-20 characters. Only letters and numbers are allowed.</div>
                <jet-input-error
                  :message="form.errors.keyword"
                  class="mt-2"
                />
              </div>
              <div class="w-1/2 lg:pl-2">
                <multiselect
                    v-model="selectedGroup"
                    :options="groupOptions"
                    label="label"
                    placeholder="Select a list"
                    select-label=""
                    deselect-label=""
                />

                <jet-input-error
                  :message="form.errors.group"
                  class="mt-2"
                />
              </div>
              <div>
                <p v-if="!$page.props.groups" class="text-sm bg-red-200 rounded p-2 inline-block text-red-800 my-4">You have to <Link href="/groups" class="underline">create a list</Link> before you can create a keyword</p>

                <jet-button class="bg-orange-400 hover:bg-orange-500 active:bg-orange-600 focus:bg-orange-600 focus:ring-orange inline-flex items-center px-4 py-2 border border-transparent rounded-md font-bold text-xs text-white uppercase tracking-widest focus:outline-none transition ease-in-out duration-150">
                    Create Keyword
                </jet-button>
              </div>
            </div>
            </form>
        </div>
      </div>
    </div>
  </app-layout>
</template>

<script>
import AppLayout from "../../Layouts/AppLayout";

export default {
  mounted() {
  },
  components: {
    AppLayout,
  },
  props: {
  },
  
  data() {
    return {
      form: this.$inertia.form(
        {
          group: null,
          keyword: null,
        },
        {
          bag: "createKeyword",
          resetOnSuccess: true
        }
      ),
        selectedGroup: null
    };
  },
  computed: {
    groupOptions() {
      return this.$page.props.groups.map(group => {
        return {
          value: group.tra_id,
          label: group.title
        };
      });
    }
  },
  methods: {
    submitHandler() {
      this.form.post(
        route("keywords.create.submit"), {
            preserveScroll: true,
            onSuccess: () => {
                this.$toasted.show("Keyword Created", {
                    position: "bottom-right",
                    type: "success",
                    duration: 3000
                });
                this.$inertia.visit(route("keywords.index"));
            },
        
        });
    }//ends submit handler
  }, //ends methods
  watch: {
    selectedGroup: function(group) {
      this.form.group = group.value;
    }
  }
};
</script>
<style>

</style>
